/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { RetailerApiAccess } from './RetailerApiAccess';
import {
    RetailerApiAccessFromJSON,
    RetailerApiAccessFromJSONTyped,
    RetailerApiAccessToJSON,
    RetailerApiAccessToJSONTyped,
} from './RetailerApiAccess';

/**
 * 
 * @export
 * @interface ApiAccess
 */
export interface ApiAccess {
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof ApiAccess
     */
    customerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAccess
     */
    retailerApiDisabled: boolean;
    /**
     * 
     * @type {RetailerApiAccess}
     * @memberof ApiAccess
     */
    retailerApiAccess?: RetailerApiAccess;
}

/**
 * Check if a given object implements the ApiAccess interface.
 */
export function instanceOfApiAccess(value: object): value is ApiAccess {
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('retailerApiDisabled' in value) || value['retailerApiDisabled'] === undefined) return false;
    return true;
}

export function ApiAccessFromJSON(json: any): ApiAccess {
    return ApiAccessFromJSONTyped(json, false);
}

export function ApiAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAccess {
    if (json == null) {
        return json;
    }
    return {
        
        'customerNumber': HeoCustomerNumberFromJSON(json['customerNumber']),
        'retailerApiDisabled': json['retailerApiDisabled'],
        'retailerApiAccess': json['retailerApiAccess'] == null ? undefined : RetailerApiAccessFromJSON(json['retailerApiAccess']),
    };
}

export function ApiAccessToJSON(json: any): ApiAccess {
    return ApiAccessToJSONTyped(json, false);
}

export function ApiAccessToJSONTyped(value?: ApiAccess | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerNumber': HeoCustomerNumberToJSON(value['customerNumber']),
        'retailerApiDisabled': value['retailerApiDisabled'],
        'retailerApiAccess': RetailerApiAccessToJSON(value['retailerApiAccess']),
    };
}

